import { render } from "./LogoutPage.vue?vue&type=template&id=2d3723c4&scoped=true"
import script from "./LogoutPage.vue?vue&type=script&lang=js"
export * from "./LogoutPage.vue?vue&type=script&lang=js"

import "./LogoutPage.vue?vue&type=style&index=0&id=2d3723c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3723c4"]])

export default __exports__